module.exports = __webpack_public_path__ + "img/cover-bg.b9078468.png";